import { put, takeLatest, call, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import appAPI from '../../api/app';
import { Types, Creators as AppCreators } from '../../reducers/app';
import getState from '../../utils/getState';

function* sendCampaignRequest({ data }) {
  const { app } = yield select(getState);
  const siteId = app.getIn(['config', 'siteId']);
  try {
    const retorno = yield call(appAPI.saveCampaign, data, siteId);
    yield put(AppCreators.sendCampaignSuccess(retorno));
  } catch (error) {
    yield put(AppCreators.sendCampaignError(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.SEND_CAMPAIGN_REQUEST, sendCampaignRequest);
}
